export default __webpack_public_path__ + "static/media/wedding-page.99203983.png";